import React from 'react';
import TableComponent from './TableComponent'
import TableTabs from './TableTabs';

function Grid3DData({ gridData, displaySettings }) {
  const freq_table = gridData.freq_table;
  const tabs = [];

  if (gridData?.Nets) {
    freq_table.statements.filter(x => x.index <= -5555).forEach(stat => {
      tabs.push({
        key: `summary-${stat.index}`,
        label: stat.label ? `Summary - ${stat.label}` : `Table ${tabs.length + 1}`,
        content: (
          <React.Fragment key={stat.index}>
            <h1>{gridData.Qtitle} - Summary  {stat.label}</h1>
            <TableComponent cols={freq_table.cols} statements={freq_table.ratings} datavalue={freq_table.datavalue}
              lvl1={"colIndex"} lvl2={"ratingIndex"} lvl3={"rowIndex"} lvl4={"statementIndex"}
              flt3={1} flt4={stat.index}
              displaySettings={displaySettings}
            />
          </React.Fragment>
        )
      });
    });
  }

  if (freq_table) {
    freq_table.ratings.forEach(rat => {
      freq_table.statements.forEach(stat => {
        tabs.push({
          key: `${stat.index}-${rat.index}`,
          label: (stat.label || rat.label) ? `${stat.label} - ${rat.label}` : `Table ${tabs.length + 1}`,
          content: (
            <React.Fragment key={`${stat.index}-${rat.index}`}>
              <h1>{gridData.Qtitle} - {stat.label} - {rat.label}</h1>
              <TableComponent cols={freq_table.cols} statements={freq_table.rows} datavalue={freq_table.datavalue}
                lvl1={"colIndex"} lvl2={"rowIndex"} lvl3={"statementIndex"} lvl4={"ratingIndex"}
                flt3={stat.index} flt4={rat.index}
                displaySettings={displaySettings}
                szr={!!gridData.szr}
              />
            </React.Fragment>
          )
        });
      });
    });
  }

  return (
    <div className="App">
      <TableTabs tabs={tabs} />
    </div>
  );
}

export default Grid3DData;
